export default __webpack_public_path__ + "static/media/summerchallenge06.6405fdea.jpg";